import { atom } from 'recoil';

export const ERROR_KINDS = {
    CelebrityDetectedError: 'CelebrityDetectedError',
    ImageModerationError: 'ImageModerationError',
    TextModerationError: 'TextModerationError',
    AudioModerationError: 'AudioModerationError',
    FaceError: 'FaceError',
    ProjectError: 'ProjectError',
    BadRequestError: 'BadRequestError',
    InsufficientCreditsError: 'InsufficientCreditsError',
    InvalidAudioFileDurationError: 'InvalidAudioFileDurationError',
    UnsupportedMimeTypeError: 'UnsupportedMimeTypeError',
    ValidationError: 'ValidationError',
};

type ModerationError = {
    kind: (typeof ERROR_KINDS)[keyof typeof ERROR_KINDS];
    extraData?: any;
};

export const moderationError = atom<ModerationError>({
    key: 'moderationError',
    default: {
        kind: '',
        extraData: null,
    },
});
